import { Col, Row, Typography } from 'antd';
import { useFetchOnListEnd } from '@admin-panel/hooks';
import { useSearchProductsInfiniteQuery } from '../../../../store/products/productsApi';
import { selectActiveFilters } from '../../../../store/products/slice';
import { useAppSelector } from '../../../../store/store';
import Filters from '../../Discovery/Filters';
import ProductCard from '../../ProductCard';

const Products = () => {
  const activeFilters = useAppSelector(selectActiveFilters);

  const { data, hasNextPage, fetchNextPage, isFetchingNextPage } = useSearchProductsInfiniteQuery({
    filters: activeFilters,
  });

  const allProducts = data?.pages.flatMap(page => page.results) || [];

  const { lastItemRef } = useFetchOnListEnd(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  });

  return (
    <>
      <Typography.Text
        style={{
          paddingLeft: '20px',
        }}
      >
        Products
      </Typography.Text>
      <Filters showTitle={false} />
      <Row gutter={[20, 24]} justify="start" style={{ padding: '20px' }}>
        {allProducts.map((product, idx) => (
          <Col
            key={product.id}
            span={24}
            ref={idx === allProducts.length - 1 ? lastItemRef : undefined}
          >
            <ProductCard data={product} />
          </Col>
        ))}
      </Row>
    </>
  );
};

export default Products;
